import Activity from './activity';
import { ApplicabilityReasons } from './control';
import Task from './tasks/task';
import Tenant from './tenant';

export default class DashboardScene {
  activities: Activity[];

  tasks: Task[];

  userOrgUnits?: Tenant[];

  constructor() {
    this.activities = [];
    this.tasks = [];
  }
}

//
// Helper classes for various widget data
//
export class NormCoverage {
  tenantId?: string;

  normId: number;

  isoNormId?: number;

  normName: string;

  controlCount: number;

  controlLinkedCount: number;

  noControlCount: number;

  outOfScopeCount: number;

  notImplementedCount: number;

  toDoCount: number;

  designingCount: number;

  implementingCount: number;

  implementedCount: number;

  applicabilityCount?: { [key in keyof ApplicabilityReasons]: number };

  constructor() {
    this.normId = 0;
    this.normName = '';
    this.controlCount = 0;
    this.implementedCount = 0;
    this.outOfScopeCount = 0;
    this.notImplementedCount = 0;
    this.noControlCount = 0;
    this.toDoCount = 0;
    this.designingCount = 0;
    this.implementingCount = 0;
    this.controlLinkedCount = 0;
  }
}

export class UserTaskStat {
  userId: string;

  taskCount: number;

  constructor() {
    this.userId = '';
    this.taskCount = 0;
  }
}

export class TaskCompletedDeadlineStat {
  //tasks completed in the period
  completedCount: number;

  //tasks completed on or before their deadline; a task without a deadline counts as on time
  onTimeCount: number;

  constructor() {
    this.completedCount = 0;
    this.onTimeCount = 0;
  }
}

export class GroupStat {
  groupId: string;

  controlCount: number;

  riskCount: number;

  constructor() {
    this.groupId = '';
    this.controlCount = 0;
    this.riskCount = 0;
  }
}
